// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"NJ-z","smallCardRow":"OJ-z","largeCardRow":"PJ-z","productSearchRow":"QJ-z","curatedRow":"RJ-z"};